import type { Marker } from '@sembo-private/maps';

import { MarkerType } from '@apps/main/modules/maps/markerFormatters';

const LOCATION_AND_DESTINATION_MARKERS = [
  MarkerType.Location,
  MarkerType.Destination,
] as string[];

type TripSummaryMarkerType = MarkerType.Destination | MarkerType.Location;

export function getLocationAndDestinationMarkers(markers: Marker[]): Marker[] {
  return markers.filter(
    (marker) =>
      marker.useContentFormatter &&
      LOCATION_AND_DESTINATION_MARKERS.includes(marker.useContentFormatter)
  );
}

export function getMarkerFormatters(): Record<
  TripSummaryMarkerType,
  (marker: Marker) => HTMLDivElement
> {
  return {
    [MarkerType.Location]: (): HTMLDivElement => {
      const div = document.createElement('div');

      div.className = 'trip-summary-location-marker';

      div.innerHTML = `<img src="https://images.sembo.travel/trip-planner/Location.png">`;

      return div;
    },
    [MarkerType.Destination]: (marker): HTMLDivElement => {
      const div = document.createElement('div');

      div.className = `trip-summary-accommodation-marker ${
        marker.cssClass || ''
      }`;
      div.innerHTML = `<img src="https://images.sembo.travel/trip-planner/Bed.png">`;
      return div;
    },
  };
}
